export const vehicle = [
  { value: "AFD" },
  { value: "FISEA" },
  { value: "FISEA+" },
  { value: "PROPARCO" },
];
